import React, { useMemo, useState } from "react";
import { TableHeader } from "../../../../../Library/DataTables";
import Moment from "moment";
import { Error404 } from "../../../../../Library/LoaderPage";
import { SessionType } from "../ConstData";
import moment from "moment";

export function TableSession({ data, setSelectedAtdid, start_dt }) {
  const selected_date = start_dt ? moment(start_dt).format("YYYY-MM-DD") : ""
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const headers = [
    { name: "No", field: "session", sortable: false },
    { name: "Schedule", field: "start_dt", sortable: false },
    { name: "Lecturer", field: "emp", sortable: false },
    { name: "Session Type", field: "status", sortable: false },
    { name: "Status", field: "status", sortable: false },
    { name: "Action", field: "section_id", sortable: false },
  ];

  const ResultData = useMemo(() => {
    let computedData = data;

    if (computedData.length > 0) {
      computedData = computedData
        .map((v) => {
          var obj = {};
          const date_st = Moment(v.start_dt).format("YYYY-MM-DD");
          obj = v;
          obj.start_date = date_st;
          return obj;
        })
        .sort((a, b) => (a.start_date < b.start_date ? 1 : -1));
    }

    return computedData;
  }, [data, sorting]);

  return (
    <div className="table-responsive">
      <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
        <TableHeader
          headers={headers}
          onSorting={(field, order) => setSorting({ field, order })}
        />
        <tbody>
          {ResultData.length > 0 ? (
            ResultData.map((v, index) => (
              <tr key={index} className={`${selected_date === v.start_date ? 'bg-light-success':''}`}>
                <td>{index + 1}</td>
                <td>
                  <ScheduleTime data={v} />
                </td>
                <td>
                  <LecturerList data={v} />
                </td>
                <td><Session_Type id={v.session_type} /></td>
                <td>
                  <StatusData data={v} />
                </td>
                <td>
                  <ButtonAction data={v} setData={setSelectedAtdid} />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10">
                <Error404 />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

const ScheduleTime = ({ data }) => {
  return (
    <span className="text-dark-75 font-weight-bolder mb-1 font-size-lg">
      <span className="d-block">
        {Moment(data.start_dt).format("D MMM YYYY")}
      </span>
      <span className="font-size-sm text-dark-50">
        {Moment(data.start_dt).format("hh:mm a")} -{" "}
        {Moment(data.end_dt).format("hh:mm a")}
      </span>
    </span>
  );
};

const LecturerList = ({ data }) => {
  return (
    <>
      <span className="text-dark-75 font-weight-bolder mb-1 font-size-lg d-block">
        {data.emp ? data.emp.fullname : "-"}
      </span>
      <span className="text-dark-50 font-weight-bolder mb-1 font-size-sm d-block">
        Teaching Topic
      </span>
      <span
        className="text-dark-50 font-weight-bolder mb-1 font-size-sm d-block"
        title={data.teaching_topic}
      >
        {data.teaching_topic
          ? data.teaching_topic.length > 100
            ? data.teaching_topic.substring(0, 100) + "..."
            : data.teaching_topic
          : "-"}
      </span>
    </>
  );
};

const Session_Type = ({ id }) => {
  const findName = SessionType.find(item => item.id === id);
  if (findName) {
    return (
      <div>
        <span className="font-weight-bold">{findName.name}</span>
      </div>
    )
  } else {
    return "";
  }
}

const StatusData = ({ data }) => {
  return (
    <>
      <span className="text-dark-75 font-weight-bolder mb-1 font-size-lg d-block">
        {data.status}
      </span>
      <span className="text-dark-50 font-weight-bolder mb-1 font-size-sm">
        {data.lec_tap_time
          ? Moment(data.lec_tap_time).format("D MMM YYYY, hh:mm a")
          : "-"}
      </span>
    </>
  );
};

const ButtonAction = ({ data, setData }) => {
  return (
    <div className="btn-group">
      <button
        className="btn btn-icon btn-light btn-sm"
        type="button"
        title="Detail"
        onClick={() => { setData(data); window.scrollTo(0, 0); }}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <polygon points="0 0 24 0 24 24 0 24"></polygon>
              <rect
                fill="#000000"
                opacity="0.3"
                transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)"
                x="11"
                y="5"
                width="2"
                height="14"
                rx="1"
              ></rect>
              <path
                d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                fill="#000000"
                fillRule="nonzero"
                transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"
              ></path>
            </g>
          </svg>
        </span>
      </button>
    </div>
  );
};
